import ClassModel from "#src/models/ClassModel.ts";
import OrganizationModel from "#src/models/OrganizationModel.ts";
import UserModel from "#src/models/UserModel.ts";
import {
  coupons,
  Event,
  GroupRegistrationStatus,
  type StudentInfoRequestResponsePayload,
} from "#types/code-generator.ts";
import CustomerInfoRequestResponseModel from "./CustomerInfoRequestResponseModel.ts";
import CustomerRequestModel from "./CustomerRequestModel.ts";
import DiscountModel from "./DiscountModel.ts";
import { InvoiceItemModel } from "./InvoiceItemModel.ts";
import PaymentModel from "./PaymentModel.ts";

export const isGroupRegistration = (
  registration
): registration is GroupRegistrationModel => {
  return (
    registration instanceof GroupRegistrationModel ||
    ((registration.student !== undefined ||
      registration.roster !== undefined) &&
      registration.class !== undefined)
  );
};

export default class GroupRegistrationModel {
  accountOwner: UserModel;
  addons: { id: string }[];
  class: ClassModel;
  coupons: coupons["coupons"];
  createdAt: Date;
  createdBy: UserModel;
  customerInfoRequestResponses: CustomerInfoRequestResponseModel[] = [];
  customerRequest: CustomerRequestModel;
  dateApproved: Date;
  discounts: DiscountModel[];
  events: Event[] = [];
  finalDate: Date;
  id: string;
  invoiceItems: InvoiceItemModel[];
  note: string;
  organization: OrganizationModel;
  reason: string;
  roster?: UserModel[];
  status: GroupRegistrationStatus;
  student?: UserModel;
  studentId?: string;
  studentInfoRequestResponses: StudentInfoRequestResponsePayload[] = [];
  transactions: PaymentModel[];
  unread: boolean = true;
  updatedAt: Date;

  // Session keys
  approvedWaitlist?: boolean;
  error?: string;

  constructor(data: any = {}) {
    Object.assign(this, data);

    if (data?.class) {
      if (data.class.active !== undefined) {
        delete data.class.active;
      }

      this.class = new ClassModel(data.class);
    }
  }
}
